import { Clear } from '@mui/icons-material';
import {
  Box,
  IconButton,
  Pagination,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import useGetProductBranchsList from 'api/productDetail/useGetProductBranchList/useGetProductBranchList';
import useProductDetail from 'api/productDetail/useProductDetail/useProductDetail';
import CodingCreateDialog from 'components/shared/BranchSystemCreate/Dialog';
import CoddingMappingModal from 'components/shared/Modals/productsList/CoddingMapping/CoddingMapping';
import BranchProductGallery from 'components/shared/Modals/productsList/Gallery/BranchProductGallery/BranchProductGallery';
import OriginProductGallery from 'components/shared/Modals/productsList/Gallery/OriginProductGallery/OriginProductGallery';
import ManualProductCodding from 'components/shared/Modals/productsList/ProductCoddingEditModal/ProductCoddingEditModal';
import ProductAccordion from 'components/shared/productDetail/ProductAccordion/ProductAccordion';
import ProductDetailHeader from 'components/shared/productDetail/ProductDetailHeader/ProductDetailHeader';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import PermissionGuard from 'hooks/permissions/PermissionGuard';
import { permissions } from 'hooks/permissions/permissions';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import CreateProductCodding from '../../components/shared/Modals/productsList/CreateProductCodding/CreateProductCodding';

const ProductDetail = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState('100');
  const [searchValue, setSearchValue] = useState('');
  const [apiSearch, setApiSearch] = useState('');
  const [productGallery, setProductGallery] = useState(false);
  const [branchGallery, setBranchGallery] = useState(false);
  const [branchSystemEdit, setBranchSystemEdit] = useState(null);
  const [expand, setExpand] = useState(null);
  const [editManual, setEditManual] = useState(null);
  const [editMapping, setEditMapping] = useState(null);
  const [createCoddingGuid, setCreateCoddingGuid] = useState(null);

  const [getProductDetail, loading, productDetailObj, setProductDetailObj] =
    useProductDetail(guid);
  const [getProductBranchsList, branchsListLoading, branchsList] =
    useGetProductBranchsList(guid);

  useEffect(() => {
    getProductDetail();
    getProductBranchsList({ page, count: pageCount, search: '' });
  }, []);

  useEffect(() => {
    setPage(1);
    getProductBranchsList({ page: 1, count: pageCount, search: apiSearch });
  }, [apiSearch]);

  useEffect(() => {
    getProductBranchsList({ page, count: pageCount, search: apiSearch });
  }, [page, pageCount]);

  const refreshBranchsList = () => {
    try {
      getProductBranchsList({ page: 1, count: pageCount, search: apiSearch });
    } catch (err) {
      console.log('ERROR ON refreshBranchsList:', err);
    }
  };

  function handleConfirmBranchEdit() {
    setBranchSystemEdit(null);
  }

  function handleEditManual(
    newName,
    selectedGuid = editManual?.id,
    branchIndex = editManual?.branchIndex,
  ) {
    try {
      const copyData = { ...productDetailObj };
      copyData.branchList[branchIndex].coddingList = copyData.branchList[
        branchIndex
      ].coddingList.map(i =>
        i.guid === selectedGuid ? { ...i, codding: newName } : i,
      );

      setProductDetailObj(copyData);
      setEditManual(null);
    } catch (e) {
      getProductDetail();
      setEditManual(null);
    }
    refreshBranchsList();
  }

  function openEditManual(branchIndex) {
    return item => setEditManual({ ...item, branchIndex });
  }

  function handleSetMapping(branchIndex) {
    return item => setEditMapping({ ...item, branchIndex });
  }

  function handleUpdateMapping(
    item,
    selectedGuid = editMapping?.id,
    branchIndex = editMapping?.branchIndex,
  ) {
    try {
      const copyData = { ...productDetailObj };
      copyData.branchList[branchIndex].coddingList = copyData.branchList[
        branchIndex
      ].coddingList.map(i =>
        i.guid === selectedGuid ? { ...i, codding: item.value } : i,
      );
      setProductDetailObj(copyData);
      setEditMapping(null);
    } catch (e) {
      getProductDetail();
    }
  }

  function onCreateCoddingSuccessful() {
    setCreateCoddingGuid(null);
    getProductDetail();
    refreshBranchsList();
  }

  const handleSubmitSearch = e => {
    e.preventDefault();
    e.stopPropagation();
    setApiSearch(searchValue);
  };

  const productBranchbranchPermissions =
    permissions.general.categories.globalSettings.productManagement.productList
      .detail.branch;

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {loading ? (
        <SpinnerLoader />
      ) : (
        <>
          <ProductDetailHeader
            detail={productDetailObj}
            setProductGallery={() => setProductGallery(true)}
            setProductLabel={() => console.log(true)}
            guid={guid}
          />
          <PermissionGuard permission={productBranchbranchPermissions.view}>
            {!branchsList?.list?.length && !apiSearch ? null : (
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  direction: 'rtl',
                  mb: 2,
                }}
              >
                <form onSubmit={handleSubmitSearch}>
                  <TextField
                    variant="outlined"
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                    size="small"
                    label="جست و جو ..."
                    InputProps={{
                      // startAdornment: (
                      //   <IconButton onClick={props.onSearchSubmit}>
                      //     <Search fontSize="small" />
                      //   </IconButton>
                      // ),
                      endAdornment: (
                        <IconButton
                          title="Clear"
                          aria-label="Clear"
                          size="small"
                          style={{
                            visibility: searchValue ? 'visible' : 'hidden',
                          }}
                          onClick={() => {
                            setApiSearch('');
                            setSearchValue('');
                          }}
                        >
                          <Clear fontSize="small" />
                        </IconButton>
                      ),
                    }}
                  />
                </form>
                <Pagination
                  color="primary"
                  count={Math.ceil(branchsList?.totalCount / pageCount)}
                  page={page}
                  sx={{ direction: 'rtl' }}
                  onChange={(event, value) => setPage(value)}
                />
              </Box>
            )}
            {branchsListLoading ? (
              <SpinnerLoader />
            ) : (
              <div>
                <Paper
                  square
                  elevation={2}
                  sx={{
                    display: { xs: 'none', lg: 'flex' },
                    bgcolor: 'rgba(15, 30, 50, .05)',
                    p: 2,
                  }}
                >
                  <Typography
                    sx={{
                      width: { xs: 'auto', lg: '400px', xl: '500px' },
                      mr: '70px',
                    }}
                    color="text.secondary"
                  >
                    نام
                  </Typography>
                  <Typography color="text.secondary">کدینگ</Typography>
                </Paper>

                {branchsList?.list?.map((branch, index) => (
                  <ProductAccordion
                    detail={branch}
                    keyIndex={index}
                    key={branch.guid}
                    getProductDetail={getProductDetail}
                    refreshProductBranchList={refreshBranchsList}
                    setBranchGallery={() => setBranchGallery(branch.guid)}
                    setSystemEdit={setBranchSystemEdit}
                    setManualEdit={openEditManual(index)}
                    setEditMapping={handleSetMapping(index)}
                    setCreateCoddingGuid={() =>
                      setCreateCoddingGuid(branch.guid)
                    }
                    expanded={expand}
                    setExpand={() =>
                      setExpand(prev =>
                        branch.guid === prev ? null : branch.guid,
                      )
                    }
                    refetchDetails={() =>
                      getProductBranchsList({
                        page,
                        count: pageCount,
                        search: apiSearch,
                      })
                    }
                  />
                ))}
              </div>
            )}
          </PermissionGuard>
        </>
      )}

      <OriginProductGallery
        open={productGallery}
        onClose={() => setProductGallery(false)}
        selected={guid}
      />

      <ManualProductCodding
        open={!!editManual}
        handleClose={() => setEditManual(null)}
        chosenProduct={editManual}
        onUpdate={handleEditManual}
      />

      <BranchProductGallery
        open={Boolean(branchGallery)}
        onClose={() => setBranchGallery(null)}
        selected={branchGallery}
      />

      <CoddingMappingModal
        open={!!editMapping}
        onClose={() => setEditMapping(null)}
        onUpdate={handleUpdateMapping}
        guid={editMapping?.id}
      />

      <CodingCreateDialog
        open={!!branchSystemEdit}
        onClose={() => setBranchSystemEdit(null)}
        handleConfirm={handleConfirmBranchEdit}
        selected={branchSystemEdit}
      />

      <CreateProductCodding
        open={!!createCoddingGuid}
        onClose={() => setCreateCoddingGuid(null)}
        selectedGuid={createCoddingGuid}
        onSuccess={onCreateCoddingSuccessful}
      />
    </>
  );
};

export default ProductDetail;
